import { PageMap } from '@wix/wixstores-client-core';
export var toCart = function (_a) {
    var context = _a.context, origin = _a.origin;
    return function () {
        return context.siteStore.navigate({
            sectionId: PageMap.CART,
            queryParams: { origin: origin },
        }, true);
    };
};
//# sourceMappingURL=toCart.js.map